var exports = {
  "ms": "ReviewThreadContainer__6BUXsu",
  "r1": "ReviewThreadHeading__Lwu5kG",
  "m3": "ReviewThreadInnerContainer__U7X0jQ",
  "Vo": "SpinnerWrapper__QIBxsQ",
};

module.exports = exports;
